const translationObject = {
  title: 'Upload | Uploads',
  placeholder: 'Select upload',
  dragDrop: 'Drag and drop files here to upload.',
  uploadedSuccessfully:
    'Successfully uploaded {count} asset | Successfully uploaded {count} assets.',
} as const;

export default translationObject;
